import landingExperienceDark from "../../../../src/pages/rovo-ui/illustration/_assets/landing-experience-dark.png";
import landingExperienceLight from "../../../../src/pages/rovo-ui/illustration/_assets/landing-experience-light.png";
import spotIllosDark from "../../../../src/pages/rovo-ui/illustration/_assets/spot-illos-dark.png";
import spotIllosLight from "../../../../src/pages/rovo-ui/illustration/_assets/spot-illos-light.png";
import * as React from 'react';
export default {
  landingExperienceDark,
  landingExperienceLight,
  spotIllosDark,
  spotIllosLight,
  React
};